import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import ScrollToTop from "@/components/ScrollToTop";
import Preloader from "@/components/Preloader";
import ScrollProgress from "@/components/ScrollProgress";
import BackToTop from "@/components/BackToTop";
import LeadPopup from "@/components/LeadPopup";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import PortfolioPage from "@/pages/PortfolioPage";
import ShopPage from "@/pages/ShopPage";
import BlogPage from "@/pages/BlogPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import QuotePage from "@/pages/QuotePage";
import GetQuotePage from "@/pages/GetQuotePage";
import IndustriesPage from "@/pages/IndustriesPage";
import PrintCataloguePage from "@/pages/PrintCataloguePage";
import PortfolioDetailPage from "@/pages/PortfolioDetailPage";
import SmoothScroll from "@/components/SmoothScroll";

import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute";
import AdminPortfolioPage from "@/pages/admin/AdminPortfolioPage";
import AdminTestimonialsPage from "@/pages/admin/AdminTestimonialsPage";
import AdminServicesPage from "@/pages/admin/AdminServicesPage";
import AdminBlogPage from "@/pages/admin/AdminBlogPage";
import AdminPackagesPage from "@/pages/admin/AdminPackagesPage";
import AdminLeadsPage from "@/pages/admin/AdminLeadsPage";
import AdminContactPage from "@/pages/admin/AdminContactPage";

const PublicLayout = () => (
    <>
        <Preloader />
        <SmoothScroll />
        <ScrollToTop />
        <ScrollProgress />
        <Navbar />
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:id" element={<PortfolioDetailPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/print" element={<PrintCataloguePage />} />
            <Route path="/get-quote" element={<GetQuotePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <FloatingButtons />
        <BackToTop />
        <LeadPopup />
    </>
);

const AdminRoutes = () => (
    <AdminAuthProvider>
        <Routes>
            <Route path="login" element={<AdminLoginPage />} />
            <Route
                path="dashboard"
                element={
                    <AdminProtectedRoute>
                        <AdminLayout />
                    </AdminProtectedRoute>
                }
            >
                <Route index element={<Navigate to="portfolio" replace />} />
                <Route path="portfolio" element={<AdminPortfolioPage />} />
                <Route path="testimonials" element={<AdminTestimonialsPage />} />
                <Route path="services" element={<AdminServicesPage />} />
                <Route path="blog" element={<AdminBlogPage />} />
                <Route path="packages" element={<AdminPackagesPage />} />
                <Route path="leads" element={<AdminLeadsPage />} />
                <Route path="contact" element={<AdminContactPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
    </AdminAuthProvider>
);

function App() {
    return (
        <div className="App bg-[#050505] text-white min-h-screen">
            <BrowserRouter>
                <Routes>
                    <Route path="/admin/*" element={<AdminRoutes />} />
                    <Route path="/*" element={<PublicLayout />} />
                </Routes>
                <Toaster
                    theme="dark"
                    position="top-center"
                    toastOptions={{
                        classNames: {
                            toast: "bg-zinc-950 border border-white/10 text-white font-inter",
                            description: "text-zinc-400",
                            actionButton: "bg-gold text-black",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
